import {
    PRODUCT_TAGGING_MODAL_OFFSET_FROM_BOX,
    PRODUCT_TAGGING_MODAL_OFFSET_FROM_TAG,
    TAG_SIZE_NON_ADMIN_EXPANDED,
} from '../constant';

export type Placement = 'left-start' | 'right-start';

export const getConfigPopper = (ref: Element, placement?: Placement) => {
    if (!placement) {
        placement = 'left-start';
    }
    return {
        placement: placement,
        strategy: 'absolute',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [
                        (TAG_SIZE_NON_ADMIN_EXPANDED / 2) * -1,
                        PRODUCT_TAGGING_MODAL_OFFSET_FROM_TAG,
                    ],
                },
            },
            {
                name: 'preventOverflow',
                options: {
                    boundary: ref,
                    rootBoundary: ref,
                    padding: PRODUCT_TAGGING_MODAL_OFFSET_FROM_BOX,
                },
            },
            {
                name: 'eventListeners',
                options: {
                    scroll: false,
                },
            },
        ],
    };
};
